import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useChatDetailLocationState } from './useChatDetailLocationState';

export const useClearPendingMessageFromLocation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useChatDetailLocationState();

  return useCallback(() => {
    if (!state?.pendingMessage) {
      return;
    }

    void navigate(location, { replace: true, state: { ...state, pendingMessage: undefined } });
  }, [location, navigate, state]);
};
